export default function NotFound(){
    return (
        <div><h1>Not Found</h1><p>We can't find what you're looking for...</p></div>
    )
}